import { useRouter } from 'next/router'
import React from 'react'

import { Link, Loading } from '../../../../components'
import { useAlgoEditorState } from '../../../../state'
import { FinalCodeResult } from '../../AlgoEditor.types'

function NextQuestionTab({
  finalSubmissionResponse
}: {
  finalSubmissionResponse: FinalCodeResult | undefined
}) {
  const router = useRouter()
  const queSlug = router.query.slug
  const { nextAlgoQuestionSlug } = useAlgoEditorState()
  if (!finalSubmissionResponse) return <Loading />

  return (
    <>
      {finalSubmissionResponse &&
        finalSubmissionResponse.status === 'Accepted' && (
          <div className="flex flex-col justify-around px-6 py-2 my-4">
            <div className="text-2xl font-semibold">Congratulations</div>
            <div className="flex flex-col">
              <div className="my-6">
                You solved this challenge 🎉🎉. Let&apos;s Try the next
                challenge.
              </div>
              <div className="flex flex-row">
                <Link
                  href={`/algo-challenges/${queSlug}`}
                  className="px-5 py-1.5 ring-1 ring-content mr-4 rounded-sm text-lg font-medium text-content-medium cursor-pointer hover:bg-zinc-600 hover:text-content">
                  Redo
                </Link>

                <Link
                  href={`/algo-challenges/${nextAlgoQuestionSlug}`}
                  className="px-5 py-1.5 text-lg font-medium bg-green-600 rounded-sm cursor-pointer hover:bg-green-500">
                  Next
                </Link>
              </div>
            </div>
          </div>
        )}
    </>
  )
}

export default NextQuestionTab
